import React, {useContext, useEffect} from "react";
import {Link} from 'react-router-dom'

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';
import {Loading} from '../custom/LoadingComponent'
import SysUserTabsRenderer from "./SysUserTabsRendererComponent";
import BucketContext from "../context/BucketContext";
import * as Consts from '../constants/Consts';

const SysUserManagement = (props) => {
    console.log('___SysUserManagement___');

    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        // props.loadComponentData();

        if(bucketContext.bucket.mostRecentUserId != null) {
            console.log('Reseting the mostRecentUserId: ' + JSON.stringify(bucketContext.bucket.mostRecentUserId));
            bucketContext.setBucketValue({mostRecentUserId: null});
        }
    });



    if(props.dataStatus === ReduxDataStatus.IDLE || 
        props.dataStatus === ReduxDataStatus.LOADING) {
         return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else if(props.user != null) {

        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to='/sysusers'>Utilizatori</Link>
                            <Typography color="text.primary">{props.user.generalSection.lastName} {props.user.generalSection.firstName}</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <h3>{props.user?.generalSection.lastName} {props.user?.generalSection.firstName} - {Consts.COREVO_CLIENT_NAME}</h3>
                    </Box>
                    <hr/>

                    <SysUserTabsRenderer 
                        user={props.user} 
                        saveUser={props.patchUser} 
                    />

                </Stack>

            </Box>
            </Container>
        );
    } else {
        console.log('Here Here....')

        return(
            <div></div>
        );
    }

}


export default SysUserManagement